<ion-app>
  <ion-router-outlet></ion-router-outlet>
  @if (cityService.needsCityPicker()) {
    @defer {
      <app-city-picker />
    }
  }
</ion-app>

@if (showSplash()) {
  <!-- Decorative: it plays its intro and leaves. Startup runs behind it. -->
  <sale-splash
    app="conductores"
    [ready]="true"
    (finished)="onSplashFinished()">
  </sale-splash>
}